// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","274":"bc862ed9","434":"736f8f6c","445":"7c74d1de","458":"de574d86","577":"66801e42","652":"5c7fb476","682":"d5252985","783":"c66ca607","812":"e16e9c63","867":"fefd544c","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};